import { ReactElement } from 'react';

import { css } from '@emotion/react';

import Icon from '@components/common/Icon/Icon';

interface CloseButtonProps {
  closeEvent: () => void;
}

export default function CloseButton({
  closeEvent,
}: CloseButtonProps): ReactElement {
  return (
    <div css={closeButton}>
      <button type="button" aria-label="close" onClick={closeEvent}>
        <Icon icon="arrowUp" size={20} /> 접기
      </button>
    </div>
  );
}

const closeButton = css`
  border: 0px;
  font-size: 16px;
  padding: 20px 0 10px;
  grid-column: 1/3;
  button {
    margin: auto;
  }
`;
